import config from '%env-config'
export default config
